export default __webpack_public_path__ + "static/media/location.d6eb20a7.svg";